export default "__VITE_ASSET__bb5540fe__"